export default __webpack_public_path__ + "static/media/gutex_logo.1c3adc71.png";